// extracted by mini-css-extract-plugin
export default {"pageWrapper":"EDmBpCvG","content":"V6GVxVqf"};